var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0395 44.7137C21.5376 44.7137 17.4967 41.9231 15.8585 37.6837L13.7368 32.1988C13.5192 31.7006 13.288 31.3781 13.0432 31.2284C12.7969 31.0786 12.3979 31.0037 11.8463 31.0037H10.9018L10.3427 35.6404C9.71704 40.8197 5.36934 44.7137 0.210114 44.7137L4.54271 9.07173C5.17136 3.89247 9.52208 0 14.6828 0L11.6408 25.0603H12.2604C12.7727 25.0603 13.1852 24.9809 13.501 24.8219C13.8154 24.663 14.1312 24.3741 14.4456 23.9554L18.8839 17.8057C20.7034 15.2856 23.5958 13.7879 26.6802 13.7711L31.8712 13.7405L23.3057 24.7623C22.9113 25.2804 22.4791 25.7389 22.0061 26.1362C21.5331 26.5351 21.0404 26.8835 20.5296 27.1815C20.9437 27.5208 21.3019 27.9136 21.6071 28.3614C21.9124 28.8091 22.1829 29.3226 22.4186 29.9003L28.5617 44.7152H26.0395V44.7137Z",
    fill: "#FF4A01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadericon);
export default __webpack_public_path__ + "static/media/loadericon.238ed7c982e69ac881e0c60e037057bd.svg";
export { ForwardRef as ReactComponent };